import React from "react";

import OtthonFelujitasKitoltes from "../components/OtthonFelujitasKitoltes/otthonfelujitaskitoltes";

const Otthonfelujitasoskitoltes = () => {
  return <OtthonFelujitasKitoltes />;
};

export default Otthonfelujitasoskitoltes;
